import { render, staticRenderFns } from "./Purchasebuyer.vue?vue&type=template&id=d9eea4dc&"
import script from "./Purchasebuyer.vue?vue&type=script&lang=js&"
export * from "./Purchasebuyer.vue?vue&type=script&lang=js&"
import style0 from "./Purchasebuyer.vue?vue&type=style&index=0&id=d9eea4dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports